var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookmarks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 40,
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.75 30.333V8.333Q30.75 7.833 30.333 7.417Q29.917 7 29.417 7H13.208V6H29.417Q30.417 6 31.083 6.667Q31.75 7.333 31.75 8.333V30.333ZM9.25 33.5 17.917 29.792 26.583 33.5V12.5Q26.583 12 26.167 11.583Q25.75 11.167 25.25 11.167H10.583Q10.083 11.167 9.667 11.583Q9.25 12 9.25 12.5ZM8.25 35.083V12.5Q8.25 11.5 8.917 10.833Q9.583 10.167 10.583 10.167H25.25Q26.25 10.167 26.917 10.833Q27.583 11.5 27.583 12.5V35.083L17.917 30.958ZM9.25 11.167Q9.25 11.167 9.667 11.167Q10.083 11.167 10.583 11.167H25.25Q25.75 11.167 26.167 11.167Q26.583 11.167 26.583 11.167H17.917Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarks);
export default __webpack_public_path__ + "static/media/bookmarks.3566077f05a52e73234a7fd80f542ff8.svg";
export { ForwardRef as ReactComponent };